import { createFileRoute } from '@tanstack/react-router';
import { VerificationPage } from '../../features/verification/verification-page.tsx';
import { guardSection } from '../../shell/guard.ts';

interface QueueSearch {
  readonly page?: number;
}

const MAX_PAGE = 10_000;

// ?page=N keeps the queue page in the URL (constitution §5.6); anything else is dropped.
function validateSearch(search: Record<string, unknown>): QueueSearch {
  const page = Number(search['page']);
  return Number.isInteger(page) && page > 1 && page <= MAX_PAGE ? { page } : {};
}

// Verification queue (T22, spec F6): supervisor and owner (task.verify).
export const Route = createFileRoute('/_authed/verification')({
  validateSearch,
  beforeLoad: guardSection('/verification'),
  component: VerificationRoute,
});

function VerificationRoute(): React.JSX.Element {
  const { page } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <VerificationPage
      page={page ?? 1}
      onPage={(next) => void navigate({ search: next > 1 ? { page: next } : {} })}
    />
  );
}
